<div class="dash">
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
</div>

<header>
  <div class="logo">
    <a [routerLink]="[language]">
      <img
        *ngIf="logo"
        [src]="logo.url"
        [alt]="logo.alt"
        [title]="logo.title"
      />
    </a>
  </div>

  <div class="contact">
    <div *ngIf="contact" [innerHtml]="contact"></div>

    <ul class="lang">
      <li>
        <a [routerLink]="['/']"> 🇸🇪 </a>
      </li>

      <li>
        <a [routerLink]="['/fi']"> 🇫🇮 </a>
      </li>

      <li>
        <a [routerLink]="['/en']"> 🇬🇧 </a>
      </li>
    </ul>
  </div>

  <nav class="menu">
    <ul class="pages">
      <li *ngFor="let page of pages">
        <a
          [routerLink]="page.link"
          [routerLinkActive]="['is-active']"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          {{ page.title }}
        </a>
      </li>
    </ul>
  </nav>
</header>

<main>
  <router-outlet></router-outlet>
</main>

<footer>
  <div class="f-container">
    Bergbo stugor ©

    <a class="greenkey" href="https://www.greenkey.global/" target="_blank"
      >Greenkey</a
    >
  </div>
</footer>
